/*

DESIGN BREADCRUMB:
The necessity of this query can be traced back to the coupling of webServiceHelper with UserSessionContext.
Because normal queries have to go through userSession to get to webServiceHelper api functions, it makes them non-reusable in contexts without UserSession.
One possible fix would be to move away from a class(UserSessionContext) to a module for session state.
Queries could use webServiceHelper or fetch directly which would probably make them reusable across apps.

*/

import { useQuery } from '@tanstack/react-query';
import { IOperationResult } from '../../extViewmodels';
import { WebsiteContent } from '../../extViewmodels/sdk/models/Website';
import { BASE_URL } from '../constants';

const BASE_QUERY_KEY = `/website/<id>/content`;

export function useWebsiteContentListViewAppQuery({
	id,
	token,
	enabled,
}: {
	id: string;
	token: string;
	enabled?: boolean;
}) {
	return useQuery({
		queryKey: [BASE_QUERY_KEY, id],
		queryFn: async () => {
			const response = await fetch(`${BASE_URL}/website/${id}/content`, {
				headers: {
					'Content-Type': 'application/json',
					Authorization: `bearer ${token}`,
				},
			});
			const result: IOperationResult<WebsiteContent[]> = await response.json();
			return result.value;
		},
		enabled,
	});
}
